import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import RatingsPage from './page';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query RepVisitsRatingsOverviewPage($schoolYear: SchoolYear) {
    viewer {
      id
      repVisits {
        ratings {
          userList {
            id
            name
            field_last_name
            uuid
            field_profile_picture_file_url
            ratingsSummary(schoolYear: $schoolYear) {
              averageRating
              numRatings
            }
          }
          overview(schoolYear: $schoolYear) {
            num1stars
            num2stars
            num3stars
            num4stars
            num5stars
            averageRating
            numRatings
            numComments
            negativeFeedback {
              professionalism
              knowledge
              materials
              other
            }
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ schoolYear }) => ({
    variables: {
      schoolYear,
    },
  }),
});

export default SimpleLoadingComponent(graphqlData)(RatingsPage);
